module.exports = __webpack_public_path__ + "img/tp-yellow-cir.67b5f346.svg";